export var TreeItemType;
(function (TreeItemType) {
    TreeItemType[TreeItemType["WORKSPACE"] = 0] = "WORKSPACE";
    TreeItemType[TreeItemType["FOLDER"] = 1] = "FOLDER";
    TreeItemType[TreeItemType["SHEET"] = 2] = "SHEET";
    TreeItemType[TreeItemType["REPORT"] = 3] = "REPORT";
    TreeItemType[TreeItemType["DASHBOARD"] = 4] = "DASHBOARD";
    TreeItemType[TreeItemType["FAVORITE"] = 5] = "FAVORITE";
    TreeItemType[TreeItemType["WORKAPP"] = 6] = "WORKAPP";
    TreeItemType[TreeItemType["FORM"] = 7] = "FORM";
    TreeItemType[TreeItemType["WWW"] = 8] = "WWW";
    TreeItemType[TreeItemType["SIGHT"] = 9] = "SIGHT";
    TreeItemType[TreeItemType["PROJECTREGISTRY"] = 10] = "PROJECTREGISTRY";
    TreeItemType[TreeItemType["DYNAMICVIEW"] = 11] = "DYNAMICVIEW";
    TreeItemType[TreeItemType["COLLECTION"] = 12] = "COLLECTION";
    TreeItemType[TreeItemType["COLLECTIONS"] = 13] = "COLLECTIONS";
    TreeItemType[TreeItemType["CONTENT"] = 14] = "CONTENT";
    TreeItemType[TreeItemType["CONTENT_LIBRARY"] = 15] = "CONTENT_LIBRARY";
    TreeItemType[TreeItemType["BLUEPRINT"] = 16] = "BLUEPRINT";
    TreeItemType[TreeItemType["BLUEPRINTS"] = 17] = "BLUEPRINTS";
    TreeItemType[TreeItemType["INTAKE_SHEET"] = 18] = "INTAKE_SHEET";
})(TreeItemType || (TreeItemType = {}));
//# sourceMappingURL=TreeItemType.js.map